import { Typography, Box, Card } from '@mui/material';
import styled from 'styled-components';

/**
 * 정보 라벨 스타일 컴포넌트
 * 
 * 상세 페이지에서 필드 라벨을 표시하는 데 사용됩니다.
 */
export const InfoLabel = styled(Typography)`
  font-size: 0.75rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

/**
 * 정보 값 스타일 컴포넌트
 * 
 * 상세 페이지에서 필드 값을 표시하는 데 사용됩니다.
 */
export const InfoValue = styled(Typography)`
  font-size: 1rem;
  font-weight: 500;
  color: #333;
`;

/**
 * 섹션 헤더 스타일 컴포넌트
 * 
 * 상세 페이지에서 섹션 제목을 표시하는 데 사용됩니다.
 */
export const SectionHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e0e0e0;
`;

/**
 * 카드 스타일 컴포넌트
 * 
 * 상세 페이지에서 정보를 담는 카드에 사용됩니다.
 */
export const StyledCard = styled(Card)`
  height: 100%;
  transition: box-shadow 0.3s ease;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;
